import classNames from 'classnames';
import Image from '@lib/components/Image/Image';
import AvatarIcon from '@lib/assets/icons/avatar.svg?react';
import Typography from '@lib/components/Typography/Typography';
import styles from './UserPreview.module.scss';

export interface UserPreviewProps {
  avatarUrl?: string | null;
  userName: string;
  className?: string;
}

export default function UserPreview({
  avatarUrl,
  userName,
  className,
}: UserPreviewProps) {
  const userAvatar = avatarUrl ? <Image src={avatarUrl} /> : <AvatarIcon />;
  return (
    <div className={classNames(styles.userPreview, className)}>
      {userAvatar}{' '}
      <Typography variant="caption" strong>
        {userName}
      </Typography>
    </div>
  );
}
